import { Component, inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SupplierCompany } from '../../../features/quotas/models/quota.interface';

@Component({
  selector: 'app-supplier-select-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatRadioModule, MatIconModule, FormsModule],
  template: `
    <div class="select-dialog-container">
      <div class="dialog-title-row">
        <h2 mat-dialog-title>Выберите компанию</h2>
        <button mat-icon-button class="close-btn" (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="select-dialog-content">
        <p class="select-hint">От какой компании вы подаёте заявку?</p>

        <mat-radio-group [(ngModel)]="selectedId" class="company-list">
          @for (company of data.companies; track company.id) {
            <mat-radio-button [value]="company.id" class="company-option" color="primary">
              <span class="company-name">{{ company.companyName }}</span>
              <span class="company-inn">ИНН: {{ company.inn }}</span>
            </mat-radio-button>
          }
        </mat-radio-group>
      </mat-dialog-content>

      <div class="select-dialog-actions">
        <button mat-stroked-button class="add-osoo-btn" (click)="addOsoo()">
          <mat-icon>add</mat-icon>
          Добавить компанию
        </button>
        <button mat-raised-button color="primary" class="confirm-btn" [disabled]="!selectedId" (click)="onConfirm()">
          Продолжить
        </button>
      </div>
    </div>
  `,
  styles: [`
    .select-dialog-container {
      min-width: 400px;
      padding: 8px;
    }

    .dialog-title-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
    }

    .close-btn {
      color: #757575;
    }

    h2 {
      font-size: 20px !important;
      font-weight: 500 !important;
      margin-bottom: 4px !important;
    }

    .select-dialog-content {
      padding-top: 8px !important;
      max-height: 320px;
      overflow-y: auto;
    }

    .select-hint {
      color: #666;
      font-size: 14px;
      margin-bottom: 16px;
    }

    .company-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .company-option {
      display: flex;
      align-items: flex-start;
      padding: 12px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      cursor: pointer;
      transition: border-color 0.2s;
    }

    .company-option:hover {
      border-color: #1d5b37;
    }

    ::ng-deep .company-option.mat-mdc-radio-checked {
      border-color: #1d5b37;
      background: #f0f9f4;
    }

    ::ng-deep .company-option .mdc-form-field {
      width: 100%;
    }

    ::ng-deep .company-option .mdc-label {
      display: flex;
      flex-direction: column;
      gap: 4px;
      cursor: pointer;
    }

    .company-name {
      font-size: 15px;
      font-weight: 500;
      color: #222;
    }

    .company-inn {
      font-size: 13px;
      color: #888;
    }

    .select-dialog-actions {
      padding: 16px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
    }

    .add-osoo-btn,
    .confirm-btn {
      height: 36px;
    }

    .add-osoo-btn {
      color: #1d5b37;
      border-color: #1d5b37;
    }

    .actions-right {
      display: flex;
      gap: 8px;
    }

    .actions-right button {
      min-width: 110px;
    }

    @media (max-width: 480px) {
      .select-dialog-container {
        min-width: unset;
        width: 100%;
        padding: 4px;
      }

      h2 {
        font-size: 17px !important;
      }

      .select-dialog-actions {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
      }

      .add-osoo-btn,
      .confirm-btn {
        width: 100%;
        height: 44px;
        min-width: unset;
      }

      ::ng-deep .mat-mdc-dialog-content {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }

      ::ng-deep .mat-mdc-dialog-surface {
        padding: 0 !important;
      }
    }
  `]
})
export class SupplierSelectDialogComponent {
  data = inject<{ companies: SupplierCompany[] }>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<SupplierSelectDialogComponent>);
  private router = inject(Router);

  selectedId: string | null = null;

  onConfirm(): void {
    const selected = this.data.companies.find(c => c.id === this.selectedId);
    this.dialogRef.close(selected);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  addOsoo(): void {
    this.dialogRef.close(null);
    this.router.navigate(['/supplier-registration']);
  }
}
